import { collapseWhitespace } from "./plain-text";

const FALLBACK_TITLE_CHAR_LIMIT = 60;
export const CONVERSATION_PREVIEW_CHAR_LIMIT = 140;

/** Counts code points, not UTF-16 units, so a cut never splits an emoji's surrogate pair. */
const truncate = (text: string, limit: number): string | null => {
	if (text === "") return null;
	const codePoints = Array.from(text);
	if (codePoints.length <= limit) return text;
	return `${codePoints.slice(0, limit).join("").trimEnd()}…`;
};

/** A conversation's name until it has a stored title: the first line of the question that opened it. */
export const conversationFallbackTitle = (firstQuestion: string): string | null =>
	truncate(
		firstQuestion
			.trim()
			.split(/\r\n?|\n/)[0]
			?.trim() ?? "",
		FALLBACK_TITLE_CHAR_LIMIT,
	);

/** The latest answer, cut to one short line for the history list. */
export const conversationPreview = (plainText: string): string | null =>
	truncate(collapseWhitespace(plainText), CONVERSATION_PREVIEW_CHAR_LIMIT);
